<!--
 * @Autor: haoyi
 * @LastEditors: haoyi
 * @LastEditTime: 2021-11-12 10:57:48
 * @Description: 视频模块1-领导专访(视频模块之间顺序改变,代码要变更)
-->
<template>
  <div id="module1" class="interview-video part">
    <div class="ele-title">
      <img
        src="https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/title-video.png"
        alt
      />
    </div>
    <!-- 精彩视频 -->
    <div class="video-wrapper">
      <div class="video-box">
        <swiper :options="swiperOptionVideo" class="swiper-box">
          <swiper-slide
            v-for="(item, index) in videoList"
            :key="index"
            class="swiper-item swiper-no-swiping"
          >
            <div class="cover">
              <div
                :id="`videoBoxPlayer${index}`"
                class="video-detail"
                style="background: black"
              ></div>
            </div>
            <div class="description">
              {{ item.subInfo5 }}
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div
        v-show="videoList.length > 1"
        id="interviewPrevVideo"
        class="swiper-button-prev swiper-button-white"
      ></div>
      <div
        v-show="videoList.length > 1"
        id="interviewNextVideo"
        class="swiper-button-next swiper-button-white"
      ></div>
      <div
        id="interviewPagination"
        slot="pagination"
        class="swiper-pagination"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LookVideo',
  props: {
    videoList: {
      type: Array
      // default: () => []
    },
    isCity: {
      type: Boolean
    }
  },
  data () {
    const _this = this
    return {
      // 视频是否播放
      isPlay: false,
      playIndex: 0,
      playLink: '',
      // 视图窗口高度
      screenHeight: 0,
      swiperOptionVideo: {
        autoplay: false,
        noSwiping: true,
        watchOverflow: true,
        navigation: {
          nextEl: '#interviewNextVideo',
          prevEl: '#interviewPrevVideo'
        },
        on: {
          slideChange: function () {
            _this.initVideo(
              this.activeIndex,
              _this.videoList[this.activeIndex].subInfo2
            )
          }
        },
        initialSlide: 0,
        observeParents: true,
        observer: true
      }
    }
  },
  watch: {
    videoList (newVal, oldVal) {
      this.$nextTick(() => {
        this.initVideo(0, this.videoList[0].subInfo2)
      })
    }
  },
  created () {},
  mounted () {
    if (!this.isCity) {
      // 视图窗口高度
      this.screenHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      this.videoWrapper = document.querySelector('.video-wrapper')
      // this.videoWrapper &&
      //   window.addEventListener(
      //     'scroll',
      //     this.throttle(this.pageScroll, 40, 60)
      //   )
    }
    if (this.videoList.length) {
      this.$nextTick(() => {
        this.initVideo(0, this.videoList[0].subInfo2)
      })
    }
  },
  methods: {
    // 解决部分手机视频播放时,整个视频层级过高盖住吸底
    pageScroll () {
      // if (!this.isPlay) {
      //   return
      // }
      // 视频模块顶部到窗口顶部距离
      const videoTop = this.videoWrapper.getBoundingClientRect().top
      if (videoTop < 110 && this.playIndex >= 0 && this.playLink) {
        this.initVideo(this.playIndex, this.playLink)
        // this.isPlay = false
        // sessionStorage.removeItem('index')
        // document.getElementById(
        //   `interviewCcplayer${this.playIndex}`
        // ).innerHTML = ''
        // this.initVideo(this.playIndex, this.playLink)
      }
    },
    initVideo (index, src) {
      this.playIndex = index
      this.playLink = src
      window.GlobalVideo.pauseAll()
      const params = {
        id: `videoBoxPlayer${index}`,
        options: {
          sources: [{
            src
          }]
        },
        plugins: [
          new window.GlobalVideoDefaultPlugins.PausedButtonPlugin({
            bg: 'https://s.kcimg.cn/topic/images/2021-jiefangj6x/video-btn-play.png',
            bgSize: {
              width: 42,
              height: 62
            }
          })
        ]
      }
      /* eslint-disable no-new */
      new window.GlobalVideo.TxVideo(params)
      // // 播放cc视频
      // const scriptEle = document.createElement('script')
      // scriptEle.type = 'text/javascript'
      // scriptEle.src = src
      // const ccplayer = document.querySelectorAll('.interview-ccplayer')

      // this.$nextTick(res => {
      //   document
      //     .getElementById(`interviewCcplayer${index}`)
      //     .appendChild(scriptEle)
      // })
      // // 其他视频盒子清空
      // const arrTimer = setTimeout(() => {
      //   arrTimer && clearTimeout(arrTimer)
      //   Array.from(ccplayer).forEach((item, key) => {
      //     if (index !== key) {
      //       item.innerHTML = ''
      //     }
      //   })
      // }, 10)

      // const timer = setInterval(() => {
      //   const box = document.getElementById(
      //     `interviewCcplayer${this.playIndex}`
      //   )
      //   const video = box && box.querySelector('video')
      //   if (video) {
      //     timer && clearInterval(timer)
      //     video.addEventListener('play', () => {
      //       this.isPlay = true
      //       // 埋点
      //       const start = src.indexOf('vid') + 4
      //       const end = src.indexOf('&') === -1 ? src.length : src.indexOf('&')
      //       const text = this.isCity ? '二级页' : '主页面'
      //       this.setAnalytics(
      //         `解放j6x|${text}|播放视频`,
      //         src.substring(start, end)
      //       )
      //     })
      //   }
      // }, 800)
    }
  }
}
</script>
<style lang="less" scoped>
.interview-video {
  width: 750px;
  margin: 0 auto;
}
.interview-video {
  width: 100%;
  bottom: 28px;
  left: 0;
  .swiper-pagination {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 6px;
    left: 0;
    width: 100%;
    text-align: center;
  }
  /deep/.swiper-pagination-bullet {
    width: 20px;
    height: 10px;
    margin-right: 10px;
    background: #5d0900;
    opacity: 1;
    border-radius: 0;
    &.swiper-pagination-bullet-active {
      width: 30px;
      height: 10px;
      background: rgba(246, 223, 193, 1);
    }
  }
}

.video-wrapper {
  width: 729px;
  height: 620px;
  background: url(https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/video-bg.png)
    no-repeat 50% 52px;
  box-sizing: border-box;
  margin: 33px auto 0;
  position: relative;
  .video-box {
    width: 620px;
    height: 100%;
    margin: 0 auto;
  }
  .swiper-item {
    width: 100%;
    .cover {
      width: 618px;
      height: 465px;
      border: 1px solid #52e5fe;
      position: relative;
      box-sizing: border-box;
      margin: 0 auto;
      .video-detail {
        width: 100%;
        height: 100%;
      }
      .banner-img {
        display: block;
        width: 600px;
        height: 400px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .description {
      margin-top: 37px;
      font-size: 32px;
      color: #8be5ff;
      line-height: 42px;
      text-align: center;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      max-height: 80px;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 46px;
    height: 68px;

    top: 223px;
    outline-style: none;
  }
  .swiper-button-prev {
    left: 3px;
    background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/swiper-btn-prev.png')
      no-repeat 50% 50%;
  }
  .swiper-button-next {
    right: 3px;
    background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/swiper-btn-next.png')
      no-repeat 50% 50%;
  }
}
/deep/.ccH5PlayBtn {
  width: 42px;
  height: 62px;
  background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/video-btn-play.png')
    no-repeat 50% 50% !important;
  border-radius: 0px;
}
</style>
